<h1 mat-dialog-title>Log Weighted Harvest</h1>

<mat-dialog-content class="mat-typography">
  <div class="form-container">
    <form [formGroup]="form.formGroup">
      <div class="row mt-3">
        <div class="col-xl-9 col-lg-6 col-md-12">
          <app-plants-select [form]="form.plantsForm" />
        </div>

        <div class="col-xl-3 col-lg-6 col-md-12">
          <mat-form-field>
            <mat-label>Amount</mat-label>

            <input matInput [formControl]="form.controls.amountHarvested" type="number" />

            <span matSuffix class="d-flex">
              <span class="input-text-suffix">g</span>
            </span>

            <mat-hint>{{ amountHint }}</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="logHarvest()" color="primary" [disabled]="!form.isValid">Log Harvest</button>

  <app-open-form-validation-errors-dialog [formGroup]="form.formGroup" />
  <app-open-form-validation-errors-dialog [formGroup]="form.plantsForm.formGroup" />

  <button mat-raised-button mat-dialog-close [mat-dialog-close]="null">Cancel</button>
</mat-dialog-actions>
